import { Route, Routes } from "react-router-dom";
import ErrorPage from "../../pages/ErrorPage";
import AdminDashboard from "../../pages/admin/AdminDashboard";
import AdminProfile from "../../pages/admin/AdminProfile";
import Assistant from "../../pages/assistant/Assistant";
import ProgramEditor from "../../pages/programs/ProgramEditorRouter";
import PaginatedTransactions from "../../pages/payments/PaginatedTransactions";
import InvitationsManager from "../../components/users/InvitationManager";
import PaginatedReports from "../../pages/reports/PaginatedReports";
import ReportPage from "../../pages/reports/ReportPage";
import PaginatedPrograms from "../../pages/programs/PaginatedPrograms";
import ProgramPage from "../../pages/programs/ProgramPage";
import RetestManagement from "../../pages/retests/RetestManagent";
import AdminCompanyPrograms from "../../pages/programs/AdminCompanyPrograms";
import RetestPage from "../../pages/retests/RetestPage";
import PaginatedUsers from "../../pages/users/PaginatedUsers";
import OrgSettingsPage from "../../pages/settings/OrgSettingsPage";
import ResearcherProfile from "../../pages/researcher/Profile";
import CompanyManagement from "../../pages/companies/CompanyManagement";
import DelegationManagement from "../../pages/delegations/DelegationManagement";
import OnboardingDocumentationRoutes from "./OnboardingDocumentationRoutes";
import NotificationsPage from "../../pages/notifications/NotificationsPage";

const AdminManagerRoutes = () => {
  return (
    <Routes>
      <Route index element={<AdminDashboard />} />

      <Route path="programs/:id/edit" element={<ProgramEditor />} />
      <Route path="/create-program" element={<ProgramEditor />} />
      <Route path="invitation" element={<InvitationsManager />} />

      <Route path="profile/*" element={<AdminProfile />} />
      <Route path="settings/*" element={<OrgSettingsPage />} />
      <Route path="reports" element={<PaginatedReports />} />
      <Route path="reports/:id" element={<ReportPage />} />

      <Route path="programs" element={<PaginatedPrograms />} />
      <Route path="companies" element={<AdminCompanyPrograms />} />
      <Route path="companies/:companyId" element={<AdminCompanyPrograms />} />
      <Route path="programs/:id" element={<ProgramPage />} />

      <Route path="/retests" element={<RetestManagement />} />
      <Route path="/retests/:retest_id" element={<RetestPage />} />

      <Route path="users" element={<PaginatedUsers />} />
      <Route path="users/researcher-profile/:userId" element={<ResearcherProfile />} />

      <Route path="delegations" element={<DelegationManagement />} />
      <Route path="company-management" element={<CompanyManagement />} />


      <Route path="assistant/*" element={<Assistant />} />

      <Route path="payments/*" element={<PaginatedTransactions />} />
      <Route path="notifications" element={<NotificationsPage />} />

      <Route path="onboarding-documentation/*" element={<OnboardingDocumentationRoutes />} />
      <Route path="/*" element={<ErrorPage />} />
    </Routes>
  );
};

export default AdminManagerRoutes;
